import React, { ChangeEvent, FC, useState } from "react";

import BaseInput from "../../../../../components/elements/BaseInput";
import Button from "../../../../../components/elements/Button";
import classes from "../../ZipCodeSelectionSlide.module.scss";

type ZipCodesInputProps = {
  handleSaveZipCodes: (enteredZipCodes: string) => void;
};

const ZipCodesInput: FC<ZipCodesInputProps> = ({ handleSaveZipCodes }) => {
  const [inputValue, setInputValue] = useState("");

  const handleChange = (event: ChangeEvent<{}>) => {
    const { value } = event.target as HTMLInputElement;
    setInputValue(value);
  };

  const handleConfirm = () => {
    handleSaveZipCodes(inputValue);
    setInputValue("");
  };

  return (
    <div className={classes.inputContainer}>
      <BaseInput
        className={classes.input}
        variant="outlined"
        label="Enter zip codes seperated by space or comma"
        multiline
        rows={6}
        value={inputValue}
        onChange={handleChange}
      />
      <Button variant="contained" disabled={!inputValue} onClick={handleConfirm}>
        Confirm
      </Button>
    </div>
  );
};

export default ZipCodesInput;
